import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "49.996",
  height: "50",
  viewBox: "0 0 49.996 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M5.357 10.717H1.786a1.786 1.786 0 1 1 0-3.571H16.07v-5.36A1.786 1.786 0 0 1 17.856 0h14.285a1.786 1.786 0 0 1 1.786 1.786v5.36h14.285a1.785 1.785 0 0 1 0 3.571H44.64v37.497A1.786 1.786 0 0 1 42.855 50H7.143a1.786 1.786 0 0 1-1.786-1.786zm24.998-3.571V3.575H19.642v3.57zM8.928 46.429h32.14V10.717H8.928zm10.713-7.142a1.786 1.786 0 0 1-1.786-1.786V19.645a1.785 1.785 0 1 1 3.571 0V37.5a1.786 1.786 0 0 1-1.785 1.786zm10.713 0a1.786 1.786 0 0 1-1.786-1.786V19.645a1.785 1.785 0 1 1 3.571 0V37.5a1.786 1.786 0 0 1-1.785 1.786z"
  })]
});